/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Landing_DescriptionInputs */

const en_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every big goal starts with small steps.
The Starter Challenge is your first step to better focus. Step up and unlock your reward!

Ready to begin your journey?`)
};

const ar_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل هدف كبير يبدأ بخطوات صغيرة.
تحدي المبتدئين هو خطوتك الأولى نحو تركيز أفضل. تقدم خطوة وافتح مكافأتك!

هل أنت مستعد لبدء رحلتك؟`)
};

const de_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedes große Ziel beginnt mit kleinen Schritten.
Die Starter Challenge ist Ihr erster Schritt zu mehr Konzentration. Treten Sie vor und schalten Sie Ihre Belohnung frei!

Sind Sie bereit, Ihre Reise zu beginnen?`)
};

const es_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda gran meta comienza con pequeños pasos.
El Desafío Inicial es tu primer paso para concentrarte mejor. ¡Anímate y consigue tu recompensa!

¿Listo para comenzar tu viaje?`)
};

const fr_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque grand objectif commence par de petits pas. Le Défi Découverte est votre première étape vers une meilleure concentration. Relevez le défi et débloquez votre récompense !

Prêt à débuter votre aventure ?`)
};

const it_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni grande obiettivo inizia con piccoli passi. 
La sfida Iniziale è il tuo primo passo verso una migliore concentrazione. Fai un passo avanti e sblocca la tua ricompensa! 
 
Pronto a iniziare il tuo viaggio?`)
};

const ja_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きな目標も、小さな一歩から始まります。
スターターチャレンジは、集中力を高めるための最初の一歩です。ステップアップして報酬を獲得しましょう！
 
準備はできましたか？`)
};

const ko_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 원대한 목표는 작은 걸음에서 시작됩니다.
초보자 챌린지는 더 나은 집중력을 향한 첫걸음이죠. 도전하고 리워드를 받으세요!

여정을 시작할 준비가 되셨나요?`)
};

const pt_br_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo grande objetivo começa com pequenos passos.
O Desafio Inicial é seu primeiro passo para um foco melhor. Siga em frente e desbloqueie sua recompensa!

Pronto para começar sua jornada?`)
};

const ru_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждая большая цель начинается с маленьких шагов.
Задача для новичков — это ваш первый шаг к улучшенной концентрации. Сделайте этот шаг и получите свою награду!

Готовы начать свое путешествие?`)
};

const th_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกเป้าหมายใหญ่เริ่มต้นขึ้นจากก้าวเล็ก ๆ
ความท้าทายเริ่มต้นคือก้าวแรกของคุณสู่การโฟกัสที่ดียิ่งขึ้น ก้าวไปข้างหน้าและปลดล็อกรางวัลของคุณ!

พร้อมที่จะเริ่มต้นการเดินทางของคุณแล้วหรือยัง?`)
};

const tr_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her büyük hedef küçük adımlarla başlar. 
Başlangıç Mücadelesi, daha iyi odaklanmak için attığın ilk adımdır. Adım at ve ödülünün kilidini aç! 
 
Bu yolculuğa başlamaya hazır mısın?`)
};

const zh_cn_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`迈出第一步，是完成任何目标的关键。
新手任务就是你提升专注力的起点。

现在就踏出这一步，并解锁新树奖励吧！`)
};

const zh_tw_starter_challenge_landing_description = /** @type {(inputs: Starter_Challenge_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邁出第一步，是完成任何目標的關鍵。
新手任務就是你提升專注力的起點。

現在就踏出這一步，並解鎖新樹獎勵吧！`)
};

/**
* | output |
* | --- |
* | "Every big goal starts with small steps. The Starter Challenge is your first step to better focus. Step up and unlock your reward! Ready to begin your journey?" |
*
* @param {Starter_Challenge_Landing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_landing_description = /** @type {((inputs?: Starter_Challenge_Landing_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Landing_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_landing_description(inputs)
	if (locale === "ar") return ar_starter_challenge_landing_description(inputs)
	if (locale === "de") return de_starter_challenge_landing_description(inputs)
	if (locale === "es") return es_starter_challenge_landing_description(inputs)
	if (locale === "fr") return fr_starter_challenge_landing_description(inputs)
	if (locale === "it") return it_starter_challenge_landing_description(inputs)
	if (locale === "ja") return ja_starter_challenge_landing_description(inputs)
	if (locale === "ko") return ko_starter_challenge_landing_description(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_landing_description(inputs)
	if (locale === "ru") return ru_starter_challenge_landing_description(inputs)
	if (locale === "th") return th_starter_challenge_landing_description(inputs)
	if (locale === "tr") return tr_starter_challenge_landing_description(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_landing_description(inputs)
	return zh_tw_starter_challenge_landing_description(inputs)
});